import { render, staticRenderFns } from "./NonConformity.vue?vue&type=template&id=3c0bdcd6&scoped=true"
import script from "./NonConformity.vue?vue&type=script&lang=js"
export * from "./NonConformity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0bdcd6",
  null
  
)

export default component.exports